import { NodeTypes } from '@xyflow/react';

import { FirstLastFrameVideoNode } from './FirstLastFrameVideoNode';
import { GroupNode } from './GroupNode';
import { ImageEditNode } from './ImageEditNode';
import { ImageGenerationNode } from './ImageGenerationNode';
import { ImageSplitterNode } from './ImageSplitterNode';
import { ImageToVideoNode } from './ImageToVideoNode';
import { ImageUpscalerNode } from './ImageUpscalerNode';
import { InputNode } from './InputNode';
import { MusicGenerationNode } from './MusicGenerationNode';
import { NoteNode } from './NoteNode';
import { OutputNode } from './OutputNode';
import { ReferencesToVideoNode } from './ReferencesToVideoNode';
import { SelectImageNode } from './SelectImageNode';
import { TalkingVideoNode } from './TalkingVideoNode';
import { TextGenerationNode } from './TextGenerationNode';
import { TextPresetNode } from './TextPresetNode';
import { TextToSpeechNode } from './TextToSpeechNode';
import { TextToVideoNode } from './TextToVideoNode';
import { UploadNode } from './UploadNode';
import { VideoMergeNode } from './VideoMergeNode';

export { BaseNode } from './BaseNode';
export { FirstLastFrameVideoNode } from './FirstLastFrameVideoNode';
export { GroupNode } from './GroupNode';
export { ImageEditNode } from './ImageEditNode';
export { ImageGenerationNode } from './ImageGenerationNode';
export { ImageSplitterNode } from './ImageSplitterNode';
export { ImageToVideoNode } from './ImageToVideoNode';
export { ImageUpscalerNode } from './ImageUpscalerNode';
export { InputNode } from './InputNode';
export { MusicGenerationNode } from './MusicGenerationNode';
export { NoteNode } from './NoteNode';
export { OutputNode } from './OutputNode';
export { ReferencesToVideoNode } from './ReferencesToVideoNode';
export { SelectImageNode } from './SelectImageNode';
export { TalkingVideoNode } from './TalkingVideoNode';
export { TextGenerationNode } from './TextGenerationNode';
export { TextPresetNode } from './TextPresetNode';
export { TextToSpeechNode } from './TextToSpeechNode';
export { TextToVideoNode } from './TextToVideoNode';
export { UploadNode } from './UploadNode';

// Node types configuration for React Flow
export const nodeTypes: NodeTypes = {
  input: InputNode,
  upload: UploadNode,
  'select-image': SelectImageNode,
  'image-generation': ImageGenerationNode,
  'image-edit': ImageEditNode,
  'image-upscaler': ImageUpscalerNode,
  'image-splitter': ImageSplitterNode,
  'text-to-video': TextToVideoNode,
  'image-to-video': ImageToVideoNode,
  'first-last-frame-video': FirstLastFrameVideoNode,
  'references-to-video': ReferencesToVideoNode,
  'text-generation': TextGenerationNode,
  'text-preset': TextPresetNode,
  'text-to-speech': TextToSpeechNode,
  'video-merge': VideoMergeNode,
  'music-generation': MusicGenerationNode,
  'talking-video': TalkingVideoNode,
  output: OutputNode,
  note: NoteNode,
  group: GroupNode,
};
